module.exports = __webpack_public_path__ + "assets/img/20_1052.e6547d72.jpg";